import { Money } from '../utils/currency';

export interface InvoiceRow {
  title: string;
  unitPrice: Money;
  quantity: number;
  discount: number;
  taxRate: number;
}

export enum InvoiceStatus {
  DRAFT = 'DRAFT',
  SENT = 'SENT',
  PAID = 'PAID',
}

export interface Invoice {
  id: string;
  createdDate: Date;
  invoiceDate: Date;
  period: string; // Format: YYYY-MM
  invoiceRows: InvoiceRow[];
  status: InvoiceStatus;
}
